<template>
  <div v-if="!choosen">
    <div class="cookie u-pad-md u-row u-bottom u-z-middle u-wrapper-panel--sm u-pointer-none">
      <div class="u-w12of12--sm u-pointer-all">
        <div class="cookie__wrapper u-bg-blue u-white u-pad-x-md u-pad-y-sm u-pad-y-md--sm u-shodow u-radius">
          <div class="u-right u-white t-text u-marg-b-sm u-cursor-pointer" @click="onDecline">
            <span class="cookie__small">
              Continuer sans accepter
            </span>
          </div>
          <div class="t-text--small t-bold u-left">
            Nous utilisons des cookies
          </div>
          <div class="u-marg-t-sm u-marg-t-sm--sm">
            <checkbox-field
              :default="true"
              name="Fonctionnels"
              slug="fonctionnals"
              class="u-pointer-none u-marg-t-xs"
            />
            <checkbox-field
              v-for="cookie in cookies"
              :key="cookie.slug"
              @onChange="value => {cookie.value = value}"
              :default="cookie.value"
              :name="cookie.name"
              :slug="cookie.slug"
              class="u-marg-t-xs"
            />
          </div>
          <div class="u-marg-t-sm u-center">
            <app-button :isWhite="true" @click="onValidate" :main="true" :isSmall="true">
              <span class="t-text--small">
                Valider
              </span>
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxField from './CheckboxField'
import AppButton from '@/components/common/AppButton'

import { cookie } from '@/utils/storage'

export default {
  components: {
    CheckboxField,
    AppButton
  },

  data () {
    return {
      isMore: false,
      choosen: false,
      isAnalytics: true,
      analytics: false,
      cookies: [
        {name: 'Google Analytics', slug: 'analytics', value: true},
        {name: 'Linkedin', slug: 'linkedin', value: true},
        {name: 'Facebook', slug: 'facebook', value: true},
        {name: 'Hubspot', slug: 'hubspot', value: true}
        // {name: 'Youtube', slug: 'youtube', value: true}
      ]
    }
  },

  created () {
    this.isAnalyticsSet = false
    const res = cookie.getItem(`consent`)

    if (cookie.getItem(`consent`) === 'true') {
      this.choosen = true
    }

    this.getValues()
  },

  mounted () {
    this.$hub.on('cookie:open', this.onOpen)
    this.$hub.on('cookie:service', (service, value) => {
      const c = this.cookies.find(c => c.slug === service.slug)
      if (!c) {return}
      cookie.setItem(`consent_${c.slug}`, value ? 'true' : 'false')
      this.$hub.emit('cookie:update')
    })
    this.addShittyTiers()
  },

  beforeUnmount () {
    this.$hub.off('cookie:open', this.onOpen)
  },

  methods: {
    onOpen () {
      this.choosen = false
      cookie.removeItem(`consent`)
      this.getValues()
    },
    onDecline() {
      cookie.setItem(`consent`, true)
      this.choosen = true
      this.$hub.emit('cookie:update')

      this.cookies.forEach(c => {
        cookie.setItem(`consent_${c.slug}`, 'false')
      })
    },
    onValidate() {
      cookie.setItem(`consent`, true)
      this.choosen = true
      this.$hub.emit('cookie:update')

      this.setValues()
      this.addShittyTiers()
    },
    getValues () {
      this.cookies.forEach(c => {
        c.value = cookie.getItem(`consent_${c.slug}`) === 'false' ? false : true
      })
    },
    setValues () {
      this.cookies.forEach(c => {
        cookie.setItem(`consent_${c.slug}`, c.value ? 'true' : 'false')
      })
    },
    addShittyTiers () {
      this.addAnalytics()
      this.addLn()
      this.addFb()
      this.addHs()
    },
    addAnalytics() {
      if (cookie.getItem(`consent_analytics`) === 'true' && !this.isAnalyticsSet) {
        const script1 = document.createElement('script')
        script1.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=G-9KSG95S7L2')
        script1.setAttribute('async', true)
        const script2 = document.createElement('script')
        script2.innerHTML += `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-9KSG95S7L2', { 'anonymize_ip': true });`
        document.head.appendChild(script1)
        document.head.appendChild(script2)
      }
    },
    addLn() {
      if (cookie.getItem(`consent_linkedin`) === 'true' && !this.isAnalyticsSet) {
        const script1 = document.createElement('script')
        script1.innerHTML += `_linkedin_partner_id = "691833";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);`
        const script2 = document.createElement('script')
        script2.innerHTML += `(function(l) {
        if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
        window.lintrk.q=[]}
        var s = document.getElementsByTagName("script")[0];
        var b = document.createElement("script");
        b.type = "text/javascript";b.async = true;
        b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
        s.parentNode.insertBefore(b, s);})(window.lintrk);`
        document.body.appendChild(script1)
        document.body.appendChild(script2)
      }
    },
    addFb() {
      if (cookie.getItem(`consent_facebook`) === 'true' && !this.isAnalyticsSet) {
        const script = document.createElement('script')
        script.innerHTML += `!function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1115612035729770');
        fbq('track', 'PageView');`
        document.head.appendChild(script)
      }
    },
    addHs() {
      if (cookie.getItem(`consent_hubspot`) === 'true' && !this.isAnalyticsSet) {
        const script = document.createElement('script')
        script.setAttribute('src', '//js.hs-scripts.com/19919270.js')
        script.setAttribute('async', 'true')
        script.setAttribute('defer', 'true')
        script.setAttribute('hs-script-loader', 'hs-script-loader')
        document.head.appendChild(script)
      }
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'
@import '~@/styles/settings/mixins/mq'

.cookie
  position fixed
  bottom: 0
  left 0
  
  +mq($until: 'tablet')
    padding-bottom 100px
    width 100%
    height 100%
    background-color: rgba($colors.black, .5)

  &__small
    font-size .65em

  &__wrapper
    width 300px

    +mq($until: 'tablet')
      width 100%
</style>